





























import Vue from 'vue';
import { mapState } from 'vuex';
import PassengersTable from '@/components/DailyRides/PassengersTable.vue';
import NotificationForm from '@/components/DailyRides/NotificationForm.vue';

export default Vue.extend({
    components: {
        PassengersTable,
        NotificationForm,
    },
    data() {
        return {
            notificationFormOpen: false,
            noPassengers: true,
        };
    },
    computed: {
        ...mapState('rides', ['routeSelected']),
    },
    methods: {
        notificationClick() {
            this.notificationFormOpen = true;
        },
        onPassengersList(passengers: any[]) {
            const notCanceledPassengers = passengers.filter((p: any) => p.ticketStatus !== 'cancelled');
            this.noPassengers = notCanceledPassengers.length === 0;
        },
    },
});
